export default __webpack_public_path__ + "static/media/gallery6.40bfa3df.jpg";